/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:23:35
 * @LastEditTime: 2024-07-24 09:41:11
 * @Description:
 */

import React, { useState, useEffect } from 'react'
import bgPng from '../../static/YearMiddleReport2024/GroupBuying/bg.png'
import { Toast, Image, Button, Tabs, InfiniteScroll } from 'antd-mobile'
import { getPayReportListApi, emailReportPackageDownloadApi, getTeamWorkListApi, wxJsapiPayApi } from '../../api/yearEndReportApi'

// import EMailModal from '../../components/MEmail/index'
import { useNavigate } from 'react-router-dom'
import wxConfig from '../../utils/wxConfig'
import MHead from '../../components/MHead/index'
import './GroupRecords.scss'
import { useImmer } from 'use-immer'
import { countdown } from '../../utils/utils'
let timers = []
let ToGroupList = ({ dataSource }) => {

  let navigate = useNavigate()
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')


  let payParams = {}
  let originalPriceBuy = async (item) => {
    let wxJsapiPayParams = {
      'openId': userInfo.openId,
      'productIds': item.products.map(product => product.productId),
      'price': item.originalPrice - item.price, // 补差价
      payType: 2,
      isCancelTeamPay: true,
      clusterId: item.clusterId
    }
    console.log(wxJsapiPayParams)
    debugger
    let res = await wxJsapiPayApi(wxJsapiPayParams)
    if (res.status === 200) {
      payParams = {
        'appId': res.data.appId,
        'timeStamp': res.data.timeStamp,
        'nonceStr': res.data.nonceStr,
        'package': res.data.packAge,
        'signType': res.data.signType,
        'paySign': res.data.paySign,
      }

      console.log('payParams', payParams)
      wxPay()
    } else {
      Toast.show(res.msg)
    }
  }

  function onBridgeReady() {
    console.log(payParams)
    // eslint-disable-next-line no-undef
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        ...payParams,
      },
      function (res) {
        console.log('getBrandWCPayRequest', res)
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          navigate('/rlb/YearEndReport/bought')
        }
      }
    )
  }

  function wxPay() {
    if (typeof WeixinJSBridge == 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
  }

  const goGroupDetail = (item) => {
    navigate(`/rlb/YearMiddleReport2024/Detail/${item.clusterId}`)
  }
  return (
    <div className="ToGroupList">
      <div className="listWrap">
        {
          dataSource.map((item, index) => {

            return <div className="listItem" key={index} onClick={() => { goGroupDetail(item) }}>
              <div className="listItemTitle">
                <h6>{item.title}</h6>
                {/* <span>带成团，差{item.diffUserCount}人</span> */}
                <span>{item.statusDesc}</span>
              </div>
              <div className="reportItem" >
                <p>
                  {
                    item.products.map(product => {
                      return <span key={product.productId}>{product.productName}</span>
                    })
                  }
                </p>
                <p>拼团价 ￥ {item.price}</p>
              </div>
              <div className="reportFoot" >
                <div>
                  <span>拼团有效期</span>
                  <span>{item.validTime}</span>
                </div>
                <div>
                  <div onClick={(e) => {
                    e.stopPropagation()
                    originalPriceBuy(item)
                  }}>
                    <span>原价购买</span>
                    <span>取消拼团</span>
                  </div>
                  <Button className="groupBtn" color="primary" onClick={() => { goGroupDetail(item) }} >
                    查看拼团详情
                  </Button>
                </div>
              </div>
            </div>
          })
        }
      </div>
    </div>
  )
}

let GroupedList = ({ dataSource }) => {
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
  // let [visible, setVisible] = useState(false)

  let navigate = useNavigate()

  // let [selectRegionId, setSelectRegionId] = useState([])

  // let downLoadHandle = (products) => {
  //   if (userInfo.email) {
  //     send(userInfo.email, products.map(item => item.productId))
  //   } else {
  //     setSelectRegionId(products.map(item => item.productId))
  //     setVisible(true)
  //   }
  // }

  // let send = async (email, selectRegionList = selectRegionId) => {
  //   debugger
  //   let promiseList = []
  //   selectRegionList.forEach((regionId) => {
  //     promiseList.push(emailReportPackageDownloadApi({
  //       openId: userInfo.openId,
  //       email,
  //       regionId,
  //     })
  //     )
  //   })
  //   let resList = await Promise.all(promiseList)
  //   console.log(resList)
  //   Toast.show('发送成功')
  //   setVisible(false)
  // }
  const goGroupDetail = (item) => {
    navigate(`/rlb/YearMiddleReport2024/Detail/${item.clusterId}`)
  }
  return (
    <>
      <div className="GroupedList">
        <div className="listWrap">
          {
            dataSource.map((item, index) => {
              return <div className="listItem" key={index} onClick={() => { goGroupDetail(item) }}>
                <div className="listItemTitle">
                  <h6>{item.title}</h6>
                  <span>{item.statusDesc}</span>
                </div>
                <div className="reportItem" >
                  <p>
                    {
                      item.products.map(product => {
                        return <span key={product.productId}>{product.productName}</span>
                      })
                    }
                  </p>
                  <p>拼团价 ￥ {item.price}</p>
                </div>
                {
                  // item.status == 2 && <div className="reportFoot" >
                  //   <Button className="groupBtn" color="primary" onClick={() => {
                  //     // downLoadHandle(item.products)
                  //     goGroupDetail()
                  //   }}>
                  //     查看拼团详情
                  //   </Button>
                  // </div>
                }
                <div className="reportFoot" >
                  <Button className="groupBtn" color="primary" onClick={() => {
                    // downLoadHandle(item.products)
                    goGroupDetail(item)
                  }}>
                    查看拼团详情
                  </Button>
                </div>
              </div>
            })
          }

        </div>
      </div >
      {/* <EMailModal okText='确认发送' visible={visible} setVisible={setVisible} send={send} /> */}

      {/* <InfiniteScroll loadMore={loadMore} hasMore={hasMore} /> */}
    </>
  )
}

let GroupRecords = () => {
  document.title = '拼团享优惠'
  useEffect(() => {
    // wxConfig()
  }, [])

  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
  useEffect(() => {
    init()
    return () => {
      timers.forEach(t => {
        clearInterval(t)
      })
    }
  }, [])

  let init = async () => {
    let res = await getTeamWorkListApi({
      openId: userInfo.openId,
    })
    if (res.status === 200) {
      debugger
      // res.data.teamingList = [
      //   {
      //     "title": "拼团购买报告标题",
      //     "products": [
      //       {
      //         "productId": "rmu45dtzl84fk",
      //         "productName": "长三角城市群 2024-H1"
      //       }
      //     ],
      //     "validTime": "03:06:05",
      //     "diffUserCount": "2",
      //     "price": 49.00,
      //     "status": 1,
      //     "statusDesc": "状态描述",
      //   },
      //   {
      //     "title": "拼团购买报告标题",
      //     "products": [
      //       {
      //         "productId": "rmu45dtzl84fk",
      //         "productName": "长三角城市群 2024-H1"
      //       }
      //     ],
      //     "validTime": "03:16:15",
      //     "diffUserCount": "2",
      //     "price": 49.00,
      //     "status": 1,
      //     "statusDesc": "状态描述",
      //   }
      // ]
      // res.data.teamsList = [
      //   {
      //     "title": "拼团购买报告标题",
      //     "products": [
      //       {
      //         "productId": "rmu45dtzl84fk",
      //         "productName": "长三角城市群 2024-H1"
      //       }
      //     ],
      //     "validTime": "3:06:05",
      //     "diffUserCount": "2",
      //     "price": 49.00,
      //     "status": 2,
      //     "statusDesc": "状态描述",
      //   }]
      setTeamingList(res.data.teamingList)
      res.data.teamingList.forEach((item, index) => {
        let timer = countdown(item.validTime, (time) => {
          setTeamingList(_ => {
            _[index].validTime = time
          })
        })

        timers.push(timer)
      })
      setTeamedList(res.data.teamedList)

    } else {
      Toast.show(res.msg)
    }
  }
  let [teamingList, setTeamingList] = useImmer([])
  let [teamedList, setTeamedList] = useState([])

  return (
    <div className="GroupRecords">
      <MHead />
      <Image src={bgPng} fit="cover" width="100%" />
      <Tabs className="TabsTab">
        <Tabs.Tab title="待成团列表" key="1">
          <ToGroupList dataSource={teamingList} />
        </Tabs.Tab>
        <Tabs.Tab title="成团记录" key="2">
          <GroupedList dataSource={teamedList} />
        </Tabs.Tab>
      </Tabs>
    </div>
  )
}

export default GroupRecords
